module.exports = __webpack_public_path__ + "static/media/logo_webrtc.7ac057f6.png";